import { TableApi } from 'devexpress-richedit/lib/client/model-api/table/table';
import { TableDataCellProperties } from 'services/api/api-client.types.ts';

// Format: {rowIndex: {startCellIndex: endCellIndex}}
export type MergedCells = {
  [rowIndex: number]: { [startCellIndex: number]: number };
};

/**
 * Merges ranges of cells in table.
 * @param table - target table.
 * @param mergedCells - Format: {rowIndex: {startCellIndex: endCellIndex}}.
 */
export function mergeTableCells(table: TableApi, mergedCells: MergedCells) {
  for (const [rowIndex, cellsRange] of Object.entries(mergedCells)) {
    const rowIndexNumber = Number(rowIndex);
    for (const [cellStart, cellEnd] of Object.entries(cellsRange)) {
      const cellStartNumber = Number(cellStart);
      if (rowIndexNumber < table.rows.count) {
        table.mergeCells(
          { rowIndex: rowIndexNumber, cellIndex: cellStartNumber },
          { rowIndex: rowIndexNumber, cellIndex: cellEnd },
        );
      }
    }
  }
}

/**
 * Sets table cells properties and cell 'characterProperties' properties.
 */
export function applyCellsProperties(
  table: TableApi,
  cellsProperties: TableDataCellProperties[],
) {
  for (const prop of cellsProperties) {
    const cell = table.rows
      .getByIndex(prop.position.row)
      ?.cells.getByIndex(prop.position.cell);

    if (!cell) continue;

    const newCharacterProperties = { ...cell.characterProperties };

    // Without setting a default color, its value is "Auto", which breaks cell styles when exporting.
    newCharacterProperties.foreColor = 'black';

    for (const [key, value] of Object.entries(prop.style)) {
      if (value === undefined || value === null) continue;

      if (key in cell) {
        (cell as any)[key] = value;
      } else if (key in newCharacterProperties) {
        (newCharacterProperties as any)[key] = value;
      }
    }

    cell.characterProperties = newCharacterProperties;
  }
}
